<template >
  <el-dialog
    :title="'客户岗点'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-table
              :data="dataList"
              border
              style="width: 100%;">
        <el-table-column label="名称" prop="gdmc">
        </el-table-column>
        <el-table-column prop="zbjd" label="经度" width="120">
        </el-table-column>
        <el-table-column  prop="zbwd" label="纬度" width="120">
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" v-if="isAuth('gangdian:setuser')" @click="removeUser(scope.row)">移除</el-button>

            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              @current-change="currentChangeHandle"
              :current-page="pageIndex"
              :page-size="pageSize"
              :total="totalPage"
              layout="total, prev, pager, next">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>

    </span>
  </el-dialog>
</template>

<script>


  import Template from "@/template";
  export default {
    components: {Template},
    data () {
      return {
        visible: false,
        pageIndex: 1,
        pageSize:10,
        totalPage: 0,
        id: 0,
        dataList:[]
      }
    },
    created () {

    },
    methods: {
      init (id) {
        this.id =id
        this.dataList=[]
        this.pageIndex=1;
        this.totalPage=0;
        this.visible = true
          this.getDataList()
      },
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      getDataList() {
        this.$request({
          url: '/bjba/contract/gdxxList',
          method: 'get',
          params: {
            'page': this.pageIndex,
            'pageSize': this.pageSize,
            'id': this.id.replace(/\,/g, "','")
          }
        }).then(response => {
          console.log('aaaaaaaaaaaaaa'+response)
          this.dataList = response.data.data.content;
          this.totalPage = response.data.data.totalElements;
        }).catch(error => {
          console.log(error)
        });
      },
      removeUser(user){
        this.$confirm('确定要移除此岗点', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$request({
            method: 'post',
            url: '/bjba/contract/removeGd',
            params: {
              contractId:this.id,
              gdid:user.gdid
            }
          }).then((response) => {
            this.$message.success("移除成功！");
            this.getDataList();
          }).catch(err => {
            console.log(err)
            alert("删除失败！")
          })
        }).catch(() => {});
      }
    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
